import { Component, OnInit, Input } from '@angular/core';
import {SpeakerService} from '../speaker.service';
@Component({
  selector: 'fusionbar',
  templateUrl: './fusionbar.component.html',
  styleUrls: ['./fusionbar.component.css']
})
export class FusionbarComponent implements OnInit {

  public dataset: any = [];
  public options: any;

  @Input() category = 'age group';

  data = {};

  ngOnInit(): void {
    this.speakerSrv.statsChange.subscribe(stats => { this.update(stats); });
    this.options = {};
  }
  
  constructor(private speakerSrv: SpeakerService) {

  }

  update(stats) {
    const years = ['1994', '2014'];
    let cumulative = {'1994': {}, '2014': {}};
    if (stats) {
      for (let i = years.length - 1; i >= 0; i--) {
        let l = years[i];
        const objKeys = Object.keys(stats[l])
        for (let j = objKeys.length - 1; j >= 0; j--) {
          let g = stats[l][objKeys[j]];
          if(g['area'] in cumulative[l]) {
            cumulative[l][g[this.category]] += g['relative'];
          }else{
            cumulative[l][g[this.category]] = g['relative'];
          }
        }
      }
      

      const keys94 = Object.keys(cumulative['1994']).sort(); 
      const values94 = [];
      for (var i = keys94.length - 1; i >= 0; i--) {
          const k = keys94[i];
          values94.push([k, cumulative['1994'][k]]);
      }
      const keys14 = Object.keys(cumulative['2014']).sort(); 
      const values14 = [];
      for (var i = keys14.length - 1; i >= 0; i--) {
          const k = keys14[i];
          values14.push([k, cumulative['2014'][k]]);
      }
      this.dataset = [{label: "1994", data: values94,  series:{xaxis: {
            mode: "categories",
            tickLength: 0
        }, bars: { show: true }}},
         {label: "2014", data: values14,  xaxis: {
            mode: "categories",
            tickLength: 0
        }, bars: { show: true }}];
      console.log(this.dataset)
    }
    
  }
}



// WEBPACK FOOTER //
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/src/app/fusionbar/fusionbar.component.ts